(function ($) { 

    Drupal.behaviors.functions = {
        attach: function (context) {
            Drupal.behaviors.functions.consolog("Drupal.behaviors.functions()"); 
            

            //scroll to anchor
            if($(".scroll-anchor").length > 0){
                $("html, body").scrollTop($(".scroll-anchor").first().offset().top);
                $("html, body").delay(1000).scrollTop($(".scroll-anchor").first().offset().top);
                //$("html, body").delay(2000).scrollTop($(".scroll-anchor").first().offset().top);
            }
            
            /* eu cookies banner */
            /* http://alex-d.github.io/Cookies-EU-banner/ */
            /*
            var cookiesBanner = new CookiesEuBanner(function(){
                //console.log("CookiesEuBanner accepted!");
            }, true);
            */

            //museum version?!
            if($("body").hasClass("museum-version")){
                Drupal.behaviors.museumVersionUpdate();
            }
            else{
                setTimeout(function(){
                    if($("body").hasClass("museum-version")){
                        Drupal.behaviors.museumVersionUpdate();
                    }
                }, 1000);
            }
            
            // init on screen animations
            setTimeout(function(){
                Drupal.behaviors.functions.initOnScreenAnimations("main");    
			}, 100);
			
			//init popup
            if($(".popup").length > 0){
                $(".popup").each(function(){
					$(this).find(".popup__close").click(function(){
						$(this).closest(".popup").hide();
					});
				});
            }
        }
    }

    Drupal.behaviors.functions.consolog = function(message) {

        //disables all console logs!
        //console.log(message);

    }

    var _scrollReveal = null;

    Drupal.behaviors.functions.initOnScreenAnimations = function(containerClass) {
        
        //https://github.com/jlmakes/scrollreveal

        //Drupal.behaviors.functions.consolog("Drupal.behaviors.functions.initOnScreenAnimations() containerClass:" + containerClass);
        
        if(!_scrollReveal){
            _scrollReveal = new ScrollReveal({
                origin: "bottom",
                distance: "50px",
                duration: 500,
                delay: 250,
                scale: 1,
                reset: false,
                easing: "ease-out",
                viewOffset: { top: -10 },                
                beforeReveal: function (domEl) {
                    //Drupal.behaviors.functions.consolog("Drupal.behaviors.functions.initOnScreenAnimations() beforeReveal:" + $(domEl).attr("class"));
                    //Drupal.behaviors.functions.consolog("element height:" + $(domEl).height() + " offset:" + $(domEl).offset().top );
                },
                afterReveal: function (domEl) {
                    //Drupal.behaviors.functions.consolog("Drupal.behaviors.functions.initOnScreenAnimations() afterReveal:" + $(domEl).attr("class"));
                }
            });
            _scrollReveal.reveal(".homeTeaserFullMask", {distance: "0px"});
            _scrollReveal.reveal(".reveal-animate", 100);
        }

        //_scrollReveal.sync();

        /*
            homeTeaserTextSection
            homeTeaserFullMask
            homeTeaserVirtualMuseumTextSection
            homeTeaserVirtualMuseumAnimatedImage
            homeTeaserStageBuildingTextSection
            homeTeaserStageBuildingAnimatedImage
            homeTeaserArtistResidencyTextSection
            homeTeaserArtistResidencyAnimatedImage
        */                        
    }

    Drupal.behaviors.functions.detectIOS = function(context) {
        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        return iOS;
    }

    Drupal.behaviors.functions.detectIE = function(context) {

        var ua = window.navigator.userAgent;
        var version = false;

        var msie = ua.indexOf("MSIE ");
        if (msie > 0) {
            // IE 10 or older => return version number
            version = parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
        }

        var trident = ua.indexOf("Trident/");
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf("rv:");
            version = parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
        }

        var edge = ua.indexOf("Edge/");
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            version = parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
        }

        // other browser
        return version;
	}  
	
	Drupal.behaviors.functions.findGetParameter = function(parameterName) {
		var result = null,
			tmp = [];
		location.search
			.substr(1)
			.split("&")
			.forEach(function (item) {
			  tmp = item.split("=");
			  if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
			});
		return result;
	}

})(jQuery);